import Alert from "./Alert";

export type ActionData = {
  successMessage?: string;
  warningMessage?: string;
  errorMessage?: string;
  infoMessage?: string;
};

type ActionAlertProps = {
  subtle?: boolean;
  actionData: ActionData | undefined;
};

export default function ActionAlert({ subtle, actionData }: ActionAlertProps) {
  if (actionData?.errorMessage) {
    return (
      <Alert subtle={subtle} type="error" children={actionData.errorMessage} />
    );
  }

  if (actionData?.successMessage) {
    return (
      <Alert
        subtle={subtle}
        type="success"
        children={actionData.successMessage}
      />
    );
  }

  if (actionData?.warningMessage) {
    return (
      <Alert
        subtle={subtle}
        type="warning"
        children={actionData.warningMessage}
      />
    );
  }

  if (actionData?.infoMessage) {
    return (
      <Alert subtle={subtle} type="info" children={actionData.infoMessage} />
    );
  }

  return null;
}
